import { getVisitorId } from './visitorId';

// Fire-and-forget visitor beacon — one per page load, after mount. Must never
// affect app startup, so it's fully guarded and try/caught. The backend filters
// bots/localhost; we keep the client side dead simple.
export function fireVisitBeacon(): void {
  try {
    if (!navigator.sendBeacon) return;
    // Include the stable visitor id so the backend can dedupe a returning
    // visitor across days (null in private mode → backend uses its daily hash).
    const body = new Blob([JSON.stringify({ path: location.pathname, vid: getVisitorId() })], {
      type: 'application/json',
    });
    navigator.sendBeacon('/api/visit', body);
  } catch {
    // Analytics is best-effort; swallow everything.
  }
}
